import { useRef, useEffect } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(useGSAP);

export default function ScrollAnimationBoxes() {
  const container = useRef();
  const greenRef = useRef();

  useEffect(() => {
    gsap.to(greenRef.current, {
      rotation: 360,
      duration: 2,
      ease: "none",
      scrollTrigger: {
        trigger: greenRef.current, // 이 요소가 화면에 보이면
        start: "top 80%", // 화면의 80% 지점에서 애니메이션 시작
        end: "top 30%", // 화면의 30% 지점에서 끝
        toggleActions: "play none none reverse", // 스크롤 방향에 따라 실행
        markers: true, // 디버깅을 위한 마커 (완성 후 제거 가능)
      },
    });
  }, []);

  useGSAP(
    () => {
      const elements = container.current.querySelectorAll(".box");
      elements.forEach((el) => {
        gsap.fromTo(
          el,
          { autoAlpha: 0, x: 200 },
          {
            autoAlpha: 1,
            x: 0,
            duration: 0.5,
            scrollTrigger: {
              trigger: el,
              start: "top bottom-=100",
              toggleActions: "play none none reverse",
            },
          }
        );
      });
    },
    { scope: container }
  );

  return (
    <>
      <div className="App" ref={container}>
        <div className="h-screen w-screen flex justify-center items-center text-4xl">
          Scroll Down
        </div>
        <div className="min-h-screen w-screen grid justify-center items-center mb-96">
          {[
            "green",
            "crimson",
            "orange",
            "yellow",
            "green",
            "crimson",
            "orange",
          ].map((color, index) => (
            <div
              key={index}
              className={`box h-12 w-52 text-center relative -translate-x-52 bg-[${color}] flex justify-center items-center`}
            >
              box{index + 1}
            </div>
          ))}
        </div>
      </div>
      <div className="h-screen flex flex-col items-center justify-around">
        <div
          ref={greenRef}
          className="box gradient-green bg-green-500 w-20 h-20 flex items-center justify-center text-white font-bold"
        >
          Green
        </div>
      </div>
    </>
  );
}
